<template>
  <Card dis-hover shadow>
    <div slot="title">
      <Button type="primary" :to="{name: 'login-number'}" class="mr-3">
        <b>返回</b>
      </Button>
    </div>
    <lida-table :propscolumns="columns" :data="items"></lida-table>
  </Card>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'login-number-related',
  data () {
    return {
      modalData: {},
      modalStatus: false,
      items: [],
      columns: {
        SSId: {
          title: "编号",
          key: 'SSId',
          align: "center"
        },
        name: {
          title: "名称",
          key: 'name',
          align: "center"
        },
        misve: {
          title: "啟用 / 停用",
          key: 'misve',
          align: "center",
          render: (h, params) => {
            let result = params.row.misve == 1 ? '停用' : '啟用'
            return h('button', {
              style: {
                color: params.row.misve == 1 ? 'red' : 'green',
                padding: '0px 5px'
              },
              on: {
                click: () => {
                  let newMisve = params.row.misve == 1 ? 0 : 1;
                  this.postRelated(params.row.SSId, newMisve)
                }
              }
            }, result)
          }
        },
      }
    }
  },
  computed: {
    ...mapGetters(['getmember'])
  },
  created () {
    this.getSiteSelect()
  },
  methods: {
    async getSiteSelect () {
      try {
        const res = await this.$axios.websiteManagement.setpgSetting()
        this.items = res
      } catch (error) {
        console.error(error);
      }
    },
    async postRelated (SSId, misve) {
      try {
        const obj = {
          loid: this.getmember.pid,
          items: [{
            SSId: SSId,
            misve: misve
          }]
        }
        const res = await this.$axios.websiteManagement.setpgSettingUpd(obj)
        if (res.status == 1) {
          this.$Message.success('修改成功');
          this.getSiteSelect()
        }
      } catch (error) {
        console.error(error);
      }
    },
  }
}
</script>